// extracted by mini-css-extract-plugin
export default {"overlay":"CalculatorBox_overlay__qyWqf","calculator":"CalculatorBox_calculator__oVfK6","hideButton":"CalculatorBox_hideButton__2uEkq"};